import DOMPurify from 'isomorphic-dompurify'
import { sanitizeRuntimeHtml as sanitizeBlockRuntimeHtml } from '@emporion/block-renderer'

const ALLOWED_TAGS = [
  'p',
  'div',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'ul',
  'ol',
  'li',
  'blockquote',
  'code',
  'pre',
  'a',
  'span',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'img',
] as const

const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'target', 'rel', 'width', 'height', 'loading'] as const

const SAFE_URI_PATTERN =
  /^(?:(?:https?|mailto|tel):|#|\/|\.\/|\.\.\/|data:image\/(?:png|gif|jpeg|jpg|webp|avif);base64,)/i

export const sanitizeRichHtml = (value: unknown): string => {
  if (typeof value !== 'string') return ''
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [...ALLOWED_TAGS],
    ALLOWED_ATTR: [...ALLOWED_ATTR],
    FORBID_TAGS: [
      'script',
      'style',
      'iframe',
      'object',
      'embed',
      'meta',
      'base',
      'link',
      'form',
      'input',
      'button',
      'textarea',
      'select',
      'option',
    ],
    FORBID_ATTR: ['style'],
    ALLOW_UNKNOWN_PROTOCOLS: false,
    ALLOWED_URI_REGEXP: SAFE_URI_PATTERN,
  })
}

export const sanitizeRuntimeHtml = (value: unknown): string => sanitizeBlockRuntimeHtml(value)
